// Use this for moving the widget to the top layer - e.g. for cropping / editing text
export const TOP_LAYER_Z_INDEX = 99999999;
